import { Ultilities } from "./ultilities"
import { cloneDeep } from "lodash"
import * as moment from 'moment'
import { LogicSearch, OperatorSearch, TypeFieldSearch } from "../vss-ui.enum"
import { BaseConditionSearchModel, ConditionSearchModel, SortSearchModel } from "../vss-ui.model"

export class FilterQuery {
  conditions: ConditionSearchModel[] = []
  sortField: SortSearchModel[] = []
  constructor(params: ConditionSearchModel[], sorts: SortSearchModel[]) {
    this.conditions = params!
    this.sortField = sorts!
  }

  static buildCondition(operator: OperatorSearch, property: string, propertyType: TypeFieldSearch, value: string): BaseConditionSearchModel {
    return { operator, property, propertyType, value }
  }

  static objectToConditions(params: any, typeParams: { [key: string]: TypeFieldSearch }, operatorParams: { [key: string]: OperatorSearch }) {
    return params && typeParams && operatorParams ? Object.keys(params).map(k => (
      this.buildCondition(operatorParams[k] || OperatorSearch.EQUAL, k, typeParams[k] || TypeFieldSearch.STRING, params[k])
    )) : []
  }

  static concatCondition(conditions: ConditionSearchModel[], values: BaseConditionSearchModel[]) {
    const index = conditions.findIndex(c => FilterQuery.hasProperty(values[0].property, c))
    if (index != -1) {
      const foundCondition = cloneDeep(conditions[index])
      if (foundCondition.expType != 'or') {
        conditions[index] = {
          expType: LogicSearch.OR,
          lstCondition: [foundCondition].concat(values)
        }
      } else {
        conditions[index] = {
          expType: LogicSearch.OR,
          lstCondition: foundCondition.lstCondition?.concat(values)
        }
      }
    } else {
      conditions = conditions.concat(values)
    }
    return conditions
  }

  static hasProperty(property: string, condition: ConditionSearchModel): boolean {
    return property == condition.property || !!condition.lstCondition?.find(c => this.hasProperty(property, c))
  }

  or(params: ConditionSearchModel[]): FilterQuery {
    const q = {
      expType: LogicSearch.OR,
      lstCondition: params
    }
    if (this.conditions.length) {
      this.conditions.push(q)
    } else {
      this.conditions = [q]
    }
    return this
  }
  and(params: ConditionSearchModel[]): FilterQuery {
    this.conditions = this.conditions.concat(params)
    return this
  }

  executeSort(data: any[]) {
    this.sortField.forEach(
      s => {
        data.sort((a, b) => {
          let v1 = a[s.fieldName]
          let v2 = b[s.fieldName]
          const dmyRegex = /\d{1,2}\/\d{1,2}\/\d{1,4}/
          const dmyhmRegex = /\d{1,2}\/\d{1,2}\/\d{1,4} \d{1,2}:\d{1,2}/
          const dmyhmsRegex = /\d{1,2}\/\d{1,2}\/\d{1,4} \d{1,2}:\d{1,2}:\d{1,2}/
          if (dmyRegex.test(v1)) {
            v1 = moment(v1, 'DD/MM/YYYY').format('X')
            v2 = moment(v2, 'DD/MM/YYYY').format('X')
          } else if (dmyhmRegex.test(v1)) {
            v1 = moment(v1, 'DD/MM/YYYY HH:mm').format('X')
            v2 = moment(v2, 'DD/MM/YYYY HH:mm').format('X')
          } else if (dmyhmsRegex.test(v1)) {
            v1 = moment(v1, 'DD/MM/YYYY HH:mm:ss').format('X')
            v2 = moment(v2, 'DD/MM/YYYY HH:mm:ss').format('X')
          }
          return v1 > v2 ? (s.sort == 'desc' ? -1 : 0) : (s.sort == 'desc' ? 0 : -1)
        })
      }
    )
    return data
  }

  executeFilter(data: any): boolean {
    let checkValidate = true
    try {
      this.conditions.forEach(
        condition => {
          const conditionValue: any = this.getValueByOperator(condition, condition.value!)
          const compareValue: any = this.getValueByOperator(condition, data[condition.property!], false)
          if (checkValidate) {
            switch (condition.operator) {
              case OperatorSearch.NOT_IN:
                checkValidate = !conditionValue.some((x: any) => x == compareValue)
                break
              case OperatorSearch.IN:
                checkValidate = conditionValue.some((x: any) => x == compareValue)
                break
              case OperatorSearch.LIKE:
                checkValidate = Ultilities.removeVietnameseAccents(`${compareValue}`).toLowerCase().includes(Ultilities.removeVietnameseAccents(`${conditionValue}`).toLowerCase())
                break
              case OperatorSearch.LOWER_EQUAL:
                checkValidate = compareValue <= conditionValue
                break
              case OperatorSearch.EQUAL:
                checkValidate = compareValue == conditionValue
                break
              case OperatorSearch.GREATER_EQUAL:
                checkValidate = compareValue >= conditionValue
                break
              case OperatorSearch.LOWER:
                checkValidate = compareValue < conditionValue
                break
              case OperatorSearch.GREATER:
                checkValidate = compareValue > conditionValue
                break
              case OperatorSearch.NOT_EQUAL:
                checkValidate = compareValue != conditionValue
                break
              default:
                checkValidate = false
            }
          }
        }
      )
    } catch (e) {
      console.error(e)
      checkValidate = false
    }
    return checkValidate
  }

  getValueByOperator(condition: ConditionSearchModel, value: any, split = true) {
    if (condition.operator === OperatorSearch.IN || condition.operator === OperatorSearch.NOT_IN) {
      return typeof value === 'string' && split ? value.split(',').map((v: any) => this.getValueByTypeField(condition, v)) : value
    } else {
      return this.getValueByTypeField(condition, value)
    }
  }


  getValueByTypeField(condition: ConditionSearchModel, value: any) {
    const formats = [
      'DD/MM/YYYY HH:mm:ss',
      'DD/MM/YYYY HH:mm',
      'DD/MM/YYYY',
      'DD-MM-YYYY HH:mm:ss',
      'DD-MM-YYYY HH:mm',
      'YYYY-MM-DD', // Add this format for your conditionValue
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DD HH:mm'
    ]
    switch (condition.propertyType) {
      case TypeFieldSearch.LONG:
      case TypeFieldSearch.INT:
        return parseInt(value)
      case TypeFieldSearch.DATE:
        return moment(value, formats).startOf('day').toDate()
      default:
        return value
    }
  }
}
